import { render } from "./ButtonDocument.vue?vue&type=template&id=06ce65df"
import script from "./ButtonDocument.vue?vue&type=script&lang=js"
export * from "./ButtonDocument.vue?vue&type=script&lang=js"
script.render = render

export default script